import axios, { AxiosInstance } from 'axios';

import { key, url } from 'pages/Authorization';
import { getDataEnv } from 'shared/hooks/useDataEnv';

// Build the shared axios instance. In local dev only, a request interceptor stamps
// `X-Sbly-Data-Env: production` whenever the "Production data" toggle is on, so the
// locally-running backend targets real production Snowflake for that request. Read live
// (per request) so flipping the toggle takes effect without rebuilding the instance. In a
// production build the header is never sent (and the deployed backend ignores it anyway).
function createHttp(accessToken?: string): AxiosInstance {
  const http = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  http.interceptors.request.use(config => {
    if (process.env.NODE_ENV !== 'production' && getDataEnv() === 'production') {
      config.headers = config.headers ?? {};
      config.headers['X-Sbly-Data-Env'] = 'production';
    }
    return config;
  });
  return http;
}

class BaseService {
  accessToken = localStorage.getItem(key)?.replace(/['"]+/g, '');
  http = createHttp(this.accessToken);

  async _getAccessToken() {
    if (!this.accessToken) {
      await new Promise(r => setTimeout(r, 1000));
      this.accessToken = localStorage.getItem(key)?.replace(/['"]+/g, '');
      this.http = createHttp(this.accessToken);
    }
  }

  async handleHttpRequest<T>(
    requestFn: () => Promise<any>,
    errorMessage: string,
  ): Promise<T | null> {
    try {
      const resp = await requestFn();
      return resp.data as T;
    } catch (err) {
      console.error(errorMessage, err);
      return null;
    }
  }
}

export default BaseService;
